<template>
  <div id="experience-form-page">
    <div class="row">
      <div class="col-md-8">
        <form class="experience-form" @submit.prevent="onSubmit">
          <fieldset>
            <legend>Basic information</legend>
            <div class="form-group row">
              <label for="title" class="form-label col-md-2">Experience Name *</label>
              <div class="col-md-10">
                <input
                  type="text"
                  class="form-control"
                  id="title"
                  v-model="experience.title"
                  required
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="description" class="form-label col-md-2">Description* (50 words max)</label>
              <div class="col-md-10">
                <input
                  type="text"
                  class="form-control"
                  id="description"
                  v-model="experience.description"
                  maxlength="50"
                  required
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="telephone" class="form-label col-md-2">Telephone Number</label>
              <div class="col-md-10">
                <input
                  type="text"
                  class="form-control"
                  id="telephone"
                  v-model="experience.telephone"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="email" class="form-label col-md-2">Email *</label>
              <div class="col-md-10">
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  v-model="experience.email"
                  required
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="address" class="form-label col-md-2">Address *</label>
              <div class="col-md-10">
                <textarea
                  rows="3"
                  class="form-control"
                  id="address"
                  v-model="experience.address"
                  required
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="country" class="form-label col-md-2">Country *</label>
              <div class="col-md-10">
                <select class="form-control" id="country" v-model="experience.location" required>
                  <option value>Country</option>
                  <option
                    v-for="country in $store.state.ref.countries"
                    :key="country.id"
                    :value="country.id"
                  >{{country.title}}</option>
                </select>
              </div>
            </div>
            <!-- <div class="form-group row">
              <label for="region" class="form-label col-md-2">Region *</label>
              <div class="col-md-10">
                <select class="form-control" id="region" v-model="experience.region">
                  <option value>Region</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="city" class="form-label col-md-2">City/District *</label>
              <div class="col-md-10">
                <select class="form-control" id="city" v-model="experience.city">
                  <option value>City</option>
                </select>
              </div>
            </div>-->
            <div class="form-group row">
              <label for="latitude" class="form-label col-md-2">Position</label>
              <div class="col-md-10">
                <div class="form-group row">
                  <label for="latitude" class="form-label col-md-3">
                    <div class="label-icon-box">
                      <i class="label-icon fas fa-map-marker-alt"></i>
                    </div>Latitude
                  </label>
                  <div class="col-md-3">
                    <input
                      type="number"
                      step="0.0000001"
                      class="form-control"
                      id="latitude"
                      v-model="experience.position.latitude"
                    />
                  </div>
                  <label for="longitude" class="form-label col-md-2">Longitude</label>
                  <div class="col-md-3">
                    <input
                      type="number"
                      step="0.0000001"
                      class="form-control"
                      id="longitude"
                      v-model="experience.position.longitude"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="what3words" class="form-label col-md-3">
                    <div class="label-icon-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21.265"
                        height="16.799"
                        viewBox="0 0 21.265 16.799"
                      >
                        <g transform="translate(-379.638 -183.044)">
                          <path
                            d="M380.873,199.843a1.236,1.236,0,0,1-1.162-1.655l5.168-14.328a1.235,1.235,0,0,1,2.324.838l-5.169,14.328A1.236,1.236,0,0,1,380.873,199.843Z"
                            fill="#fff"
                          />
                          <path
                            d="M411.208,199.843a1.236,1.236,0,0,1-1.162-1.655l5.168-14.328a1.235,1.235,0,0,1,2.324.838l-5.168,14.328A1.236,1.236,0,0,1,411.208,199.843Z"
                            transform="translate(-23.522 0)"
                            fill="#fff"
                          />
                          <path
                            d="M441.543,199.843a1.236,1.236,0,0,1-1.162-1.655l5.168-14.328a1.235,1.235,0,0,1,2.324.838L442.7,199.027A1.235,1.235,0,0,1,441.543,199.843Z"
                            transform="translate(-47.044 0)"
                            fill="#fff"
                          />
                        </g>
                      </svg>
                    </div>What3Words
                  </label>
                  <div class="col-md-7">
                    <input
                      type="text"
                      class="form-control"
                      id="what3words"
                      v-model="experience.what3words"
                      ref="what3words"
                    >
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary"  @wordsdata="showResultData" @click="onClickMapPopup()">Browse</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="socialIdentifiers" class="form-label col-md-2">Hashtag *</label>
              <div class="col-md-10">
                <input
                  type="text"
                  class="form-control"
                  id="socialIdentifiers"
                  v-model="experience.socialIdentifiers"
                />
              </div>
            </div>
          </fieldset>
          <fieldset v-if="$store.state.ref">
            <legend>Category*</legend>
            <div
              v-for="category in $store.state.ref.categories"
              :key="category.id"
              class="form-check form-check-inline mr-4"
            >
              <label :for="`category-${category.id}`">
                <input
                  type="checkbox"
                  :id="`category-${category.id}`"
                  :value="category.id"
                  class="mr-1"
                  v-model="experience.categories"
                />
                <span>{{category.title}}</span>
              </label>
            </div>
          </fieldset>
          <fieldset>
            <legend>Social Media Channels</legend>
            <div class="form-group row">
              <label for="facebookLink" class="form-label col-md-1">
                <i class="label-icon fab fa-facebook"></i>
              </label>
              <div class="col-md-11">
                <input
                  type="url"
                  class="form-control"
                  id="facebookLink"
                  placeholder="Facebook"
                  v-model="experience.facebookLink"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="instagramLink" class="form-label col-md-1">
                <i class="label-icon fab fa-instagram"></i>
              </label>
              <div class="col-md-11">
                <input
                  type="url"
                  class="form-control"
                  id="instagramLink"
                  placeholder="Instagram"
                  v-model="experience.instagramLink"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="twitterLink" class="form-label col-md-1">
                <i class="label-icon fab fa-twitter"></i>
              </label>
              <div class="col-md-11">
                <input
                  type="url"
                  class="form-control"
                  id="twitterLink"
                  placeholder="Twitter"
                  v-model="experience.twitterLink"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="pinterestLink" class="form-label col-md-1">
                <i class="label-icon fab fa-pinterest"></i>
              </label>
              <div class="col-md-11">
                <input
                  type="url"
                  class="form-control"
                  id="pinterestLink"
                  placeholder="Pinterest"
                  v-model="experience.pinterestLink"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="youtubeLink" class="form-label col-md-1">
                <i class="label-icon fab fa-youtube"></i>
              </label>
              <div class="col-md-11">
                <input
                  type="url"
                  class="form-control"
                  id="youtubeLink"
                  placeholder="Youtube"
                  v-model="experience.youtubeLink"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="vimeoLink" class="form-label col-md-1">
                <i class="label-icon fab fa-vimeo"></i>
              </label>
              <div class="col-md-11">
                <input
                  type="url"
                  class="form-control"
                  id="vimeoLink"
                  placeholder="Vimeo"
                  v-model="experience.vimeoLink"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="vkLink" class="form-label col-md-1">
                <i class="label-icon fab fa-vk"></i>
              </label>
              <div class="col-md-11">
                <input
                  type="url"
                  class="form-control"
                  id="vkLink"
                  placeholder="VK"
                  v-model="experience.vkLink"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="wechatLink" class="form-label col-md-1">
                <i class="label-icon fab fa-wechat"></i>
              </label>
              <div class="col-md-11">
                <input
                  type="url"
                  class="form-control"
                  id="wechatLink"
                  placeholder="WeChat"
                  v-model="experience.wechatLink"
                />
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>Image</legend>
            <div>
              <ImageUploadButton
                ref="imageUploader"
                :imageUrl="experience && experience.thumbnailUrl ? experience.thumbnailUrl : ''"
                @clear="onClearUploadImage"
              />
            </div>
          </fieldset>
          <div class="form-actions">
            <input type="submit" class="btn btn-primary" value="Submit" />
            <router-link :to="{ name: 'experiences' }" class="btn btn-secondary back-button">Back</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ExperienceService from "@/services/ExperienceService";
import ImageUploadButton from "@/components/ImageUploadButton";
import { getUserId } from "@/services/UserService";
import MapPopup from "@/services/MapPopup.js";

export default {
  name: "ExperienceForm",
  components: {
    ImageUploadButton,
    MapPopup,
    // LMap,
    // LTileLayer,
  },
  data() {
    return {
      id: null,
      userId: null,
      experience: {
        title: "",
        description: "",
        telephone: "",
        email: "",
        address: "",
        country: "",
        region: "",
        city: "",
        location: null,
        position: null,
        socialIdentifiers: "",
        categories: [],
        travelerTypes: [],
        facebookLink: "",
        instagramLink: "",
        twitterLink: "",
        pinterestLink: "",
        youtubeLink: "",
        vimeoLink: "",
        vkLink: "",
        wechatLink: "",
        affiliations: [],
        sliderImageUrls: [],
        thumbnailUrl: "",
        websiteLink: "",
        what3words: "",
        position: {
          lat: "",
          lng: ""
        },
        owner: null,
        creator: null,
      }
    };
  },
  mounted() {
    this.userId = getUserId();
    this.id = this.$route.params.id;
    if (this.id) {
      this.load(this.id);
    }
  },
  methods: {
    load(id) {
      this.$repo.exp.getExperience(id).then(experience => {
        if(experience.categories && experience.categories.length > 0) {
          experience.categories = experience.categories.map(it => it.id);
        }
        if(experience.travelerTypes && experience.travelerTypes.length > 0) {
          experience.travelerTypes = experience.travelerTypes.map(it => it.id);
        }
        this.experience = experience;
      });
    },
    uploadImages() {
      return this.$refs.imageUploader.upload();
    },
    save() {
      return new Promise((resolve, reject) => {
        let promise = null;
        this.experience.creator = this.userId;
        this.experience.owner = this.userId;

        if (this.id) {
          this.experience.id = this.id;
          promise = this.$repo.exp.updateExperience(this.experience);
        } else {
          promise = this.$repo.exp.createExperience(this.experience);
        }

        promise
          .then(experience => {
            if (!this.id) {
              this.id = experience.id;
              this.$router.push({
                name: "edit-experience",
                params: { id: this.id }
              });
            }
            this.$toasted.show("Save experience successfully.", {
              type: "success",
              duration: 3000,
              position: "bottom-right"
            });
            resolve(this.id);
          })
          .catch(err => {
            console.error(err);
            this.$toasted.show("Something went wrong.", {
              type: "error",
              duration: 3000,
              position: "bottom-right"
            });
            reject(err);
          });
      });
    },
    onSubmit() {
      this.uploadImages()
        .then(files => {
          console.log(files);
          if (files && files.length > 0) {
            this.experience.sliderImageUrls = files.map(file => file.url);
            this.experience.thumbnailUrl = files[0].url;
          }

          this.save();
        })
        .catch(console.log);
    },
    onClearUploadImage() {
      this.experience.sliderImageUrls = [];
      this.experience.thumbnailUrl = "";
    },
    onClickMapPopup() {
      const input = this.$refs.what3words;
      MapPopup.open(input);
    },
    showResultData(data){
      // this.experience.what3words = data;
      console.log("get method");
      console.log(data);
    }
  }
};
</script>

<style lang="scss" scoped>
#experience-form-page {
  .back-button {
    margin-left: 30px;
  }
  .label-icon-box {
    background-color: #b9b9b9;
    color: #fff;
    display: inline-block;
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
    text-align: center;
    position: relative;

    .label-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .label-icon {
    font-size: 2rem;
  }
}
</style>
